export const VALID_ROUTING_NUMBER_LENGTH = 9;

export const MINIMUM_ACCOUNT_NUMBER_LENGTH = 3;

export const IdentityVerificationStatus = {
  Failed: 'IdentityVerificationFailed',
  TryAgain: 'RetryIdentityVerification',
};

export const EnrollmentVariants = {
  CombinedScreens: 'combined_screens',
};

export const MAX_IDENTITY_VERIFICATION_ATTEMPTS = 3;

export const PaymentOptions = {
  AutoPay: 'autopay',
  ManualPay: 'manual',
};

export const ENROLLMENT_FEATURES = {
  PwGBPlus: 'payplus_unenrolled',
};

export const ANNUAL_INCOME_FEATURE_NAME = 'enrollment_income_field_variant';

export const ANNUAL_INCOME_FEATURE_VARIANT = {
  CHECKBOX: 'A_checkbox',
  TEXTINPUT: 'B_freeform',
};
